// extracted by mini-css-extract-plugin
export var assetList = "G3h4mQEeBvdeC1fdulOt";
export var assetListContainer = "IrzvfincLa4GKH5RpMBN";
export var assetTable = "_5p_k7usAdBavNFLfIbh";
export var skeleton = "dl5a9tidlaLwyIXffjU9";
export var skeletonItem = "WTYTnHstZ0GmGFjNyiJv";
export var totalValue = "btDTFOiy5hK5__XOOOZe";